import cx from "classnames";
import React from "react";
import * as styles from "./ScreenReaderOnly.module.css";
const ScreenReaderOnly = ({ children, testId = "screen-reader-only" }) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: cx(styles.root),
    "data-testid": testId
  }, children);
};
var ScreenReaderOnly_default = ScreenReaderOnly;
export {
  ScreenReaderOnly_default as default
};
